/* THESE TYPES ALSO EXIST IN packages\shared\src\types.ts START*/
/* PLEASE UPDATE BOTH LOCATIONS IF MAKING CHANGES */
/* Types have been duplicated in both location so the Launcher NPM package does not have a direct dependency on packages\shared */

type NavigationType = 'SameWindow' | 'NewWindow' | 'Workspace';

export type OnOverrideNavigateParams = {
  id: string;
  widgetId?: string;
  instanceId?: string;
  /** Evo/Workspace specific link */
  url?: string;
  /** Url for the link clicked */
  locationUrl?: string;
  navigationType: NavigationType;
};

export type OnOverrideNavigate = (event: OnOverrideNavigateParams) => boolean;

export type AccessButtonOptions = {
  inWorkspace?: boolean;
  /**
   * @deprecated Use overrideNavigation instead
   */
  overrideNavigationType?: boolean;
  /** Override function for handling domain specific links from the feed and copilot */
  overrideNavigation?: OnOverrideNavigate;
  /**
   * @deprecated Use environment instead
   */
  src?: string;
  userId?: string;
  organisationId?: string;
  applicationId?: string;
  positions?: Positions;
  colourScheme?: ColourScheme;
  view?: View;
  closedZindex?: number;
  getToken?: () => Promise<Response>;
  environment: Environment;
  intercomChatEnabled?: boolean;
  language?: string;
  /**
   * @deprecated Use positions instead
   */
  position?: DeprecatedPosition;
  onSignOut?: () => Promise<void>;
  shellOptions?: ShellOptions;
};

export type ShellOptions = {
  id: string;
  instanceId?: string;
  productName: string;
};

export type ApplicationInsightsLoggingData = AccessButtonOptions & {
  headerIsExtracted: boolean;
  launcherVersion: string;
  retries: number;
};

export type Positions = {
  parentElement?: string;
  desktop?: {
    top?: number;
    left?: number;
  };
  mobile?: {
    left?: number;
    bottom?: number;
    right?: number;
  };
};

export type DeprecatedPosition = {
  top?: number;
  left?: number;
};

export type Position = {
  top?: number;
  left?: number;
  bottom?: number;
  right?: number;
};

export type FlyoutPosition = {
  top: number;
  left: number;
};

export type View = 'desktop' | 'mobile';

export type ColourScheme = 'light' | 'dark';

/* THESE TYPES ALSO EXIST IN packages\shared\src\types.ts END*/

export type Environment =
  | 'prod'
  | 'prod-anz'
  | 'prod-us'
  | 'prod-eu'
  | 'demo'
  | 'staging'
  | 'preprod'
  | 'integration-us'
  | 'integration-eu';

export enum AccessButtonEnvironment {
  PRODUCTION = 'https://button-app.production.workspace.accessacloud.com',
  PROD_ANZ = 'https://button-app.production.workspace.access-workspace.com.au',
  PROD_US = 'https://button-app.us.access-evo.com',
  PROD_EU = 'https://button-app.eu.access-evo.com',
  DEMO = 'https://button-app.demo.workspace.accessacloud.com',
  STAGING = 'https://button-app.staging.workspace.accessacloud.com',
  LOADTEST = 'https://button-app.loadtest.workspace.accessacloud.com',
  PREPROD = 'https://button-app.preprod.workspace.accessacloud.com',
  INTEGRATION_US = 'https://button-app.integration.us.access-evo.com',
  INTEGRATION_EU = 'https://button-app.integration.eu.access-evo.com',
}

export type DecodedButtonTokenData = {
  context: {
    w_org_id: string;
    w_user_id: string;
    w_product_id?: string;
  };
};

export type UserData = {
  userId?: string;
  organisationId?: string;
  applicationId?: string;
};

export type ProductTitle = {
  instanceName?: string;
  breadcrumb?: string[];
  productName?: string;
};

export type LoadComponentsOptions = {
  environment: Environment;
};
